import { render, staticRenderFns } from "./BaseDropdownComments.vue?vue&type=template&id=3faee0ca"
import script from "./BaseDropdownComments.vue?vue&type=script&lang=js"
export * from "./BaseDropdownComments.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownComments.vue?vue&type=style&index=0&id=3faee0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports